﻿/**
 * Typed Helper Functions for Common Analytics Events
 * Connect Source Architecture
 */

import { getAnalyticsService } from '../services/analytics';

export function trackPageView(path: string, title?: string): void {
  getAnalyticsService().trackPageView(path, title);
}

export function trackProductView(slug: string, priceINR: number, currency: string = 'INR'): void {
  getAnalyticsService().track('product_view', { slug, priceINR, currency });
}

export function trackLeadMagnetView(slug: string, title: string): void {
  getAnalyticsService().track('lead_magnet_view', { slug, title });
}

export function trackLeadMagnetSubmission(slug: string, emailHash?: string): void {
  getAnalyticsService().track('lead_magnet_submission', { slug, emailHash });
}

export function trackLeadMagnetDownload(slug: string, token: string): void {
  getAnalyticsService().track('lead_magnet_download', { slug, token });
}

export function trackBuyClick(slug: string, priceINR: number): void {
  getAnalyticsService().track('buy_click', { slug, priceINR });
}

export function trackCheckoutStart(orderId: string, slug: string, amount: number): void {
  getAnalyticsService().track('checkout_start', { orderId, slug, amount });
}

export function trackPaymentSuccess(orderId: string, paymentId: string, amount: number): void {
  getAnalyticsService().track('payment_success', { orderId, paymentId, amount });
}

export function trackPaymentFailure(orderId: string, errorCode?: string, errorMessage?: string): void {
  getAnalyticsService().track('payment_failure', { orderId, errorCode, errorMessage });
}

export function trackProductDownload(productId: string, fileId: string): void {
  getAnalyticsService().track('product_download', { productId, fileId });
}

export function trackConsultationClick(serviceCategory: string, source: string): void {
  getAnalyticsService().track('consultation_click', { serviceCategory, source });
}

export function trackWhatsAppClick(intent: string, page: string): void {
  getAnalyticsService().track('whatsapp_click', { intent, page });
}

export function trackContactSubmission(topic: string): void {
  getAnalyticsService().track('contact_submission', { topic });
}

